(function () {
  'use strict';

  /* =========================
     Configuration
  ========================== */
  var WEBHOOK_URL = 'https://automation.ethicalhq.com/webhook/1b6b2ddb-6a38-488a-9709-44947e3223d5';
  var REDIRECT_URL = '/pages/thank-you-roasters-registration';
  var SUBMITTING_TEXT = 'Submitting\u2026';

  var turnstileWidgetId = null;

  /* =========================
     Init
  ========================== */
  document.addEventListener('DOMContentLoaded', function () {
    var form = document.getElementById('roasters-registration');
    if (!form) return;

    initOtherFields(form);
    initTurnstile(form);

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      handleSubmit(form);
    }, true);
  });

  /* =========================
     "Other" field show/hide
  ========================== */
  function initOtherFields(form) {
    // Select → show/hide sibling textarea when "Other" selected
    var selects = form.querySelectorAll('[data-field-hide="select"]');
    selects.forEach(function (select) {
      select.addEventListener('change', function () {
        var other = select.closest('.cn-form__field-group').querySelector('[data-field-hide="true"]');
        if (!other) return;
        other.style.display = select.value.toLowerCase() === 'other' ? 'block' : 'none';
      });
    });

    // Checkbox "Other" → show/hide sibling textarea
    var checkboxes = form.querySelectorAll('[data-field-hide="check"]');
    checkboxes.forEach(function (cb) {
      cb.addEventListener('change', function () {
        if (cb.name.toLowerCase() !== 'other') return;
        var other = cb.closest('.cn-form__field-group').querySelector('[data-field-hide="true"]');
        if (!other) return;
        other.style.display = cb.checked ? 'block' : 'none';
      });
    });
  }

  /* =========================
     Turnstile
  ========================== */
  function initTurnstile(form) {
    var container = form.querySelector('.turnstile-container');
    if (!container || !window.turnstile || !window.TURNSTILE_SITE_KEY) {
      console.error('Turnstile not ready for Roasters Registration');
      return;
    }

    turnstile.ready(function () {
      turnstileWidgetId = turnstile.render(container, {
        sitekey: window.TURNSTILE_SITE_KEY,
        size: 'invisible',
        execution: 'execute',
        action: 'roasters_registration',
        callback: onTurnstileSuccess,
        'error-callback': onTurnstileError
      });
    });
  }

  /* =========================
     Submit handler
  ========================== */
  function handleSubmit(form) {
    var submitBtn = document.getElementById('roaster-reg');

    if (!validateForm(form)) return;

    if (submitBtn) {
      submitBtn.textContent = SUBMITTING_TEXT;
      submitBtn.disabled = true;
    }

    if (!turnstileWidgetId) {
      resetBtn(submitBtn);
      alert('Verification unavailable. Please refresh and try again.');
      return;
    }

    turnstile.execute(turnstileWidgetId);
  }

  /* =========================
     Turnstile success callback
  ========================== */
  function onTurnstileSuccess(token) {
    var form = document.getElementById('roasters-registration');
    var submitBtn = document.getElementById('roaster-reg');
    if (!form) return;

    var tokenInput = form.querySelector('[name="turnstile_token"]');
    if (tokenInput) tokenInput.value = token;

    var payload = collectFormData(form);
    payload.turnstile_token = token;

    sendToWebhook(payload)
      .then(function () {
        window.location.href = REDIRECT_URL;
      })
      .catch(function (err) {
        console.error('Roasters Registration error:', err);
        alert('Something went wrong. Please try again.');
        resetBtn(submitBtn);
      });
  }

  function onTurnstileError() {
    var submitBtn = document.getElementById('roaster-reg');
    alert('Verification failed. Please try again.');
    resetBtn(submitBtn);
  }

  /* =========================
     Form validation
  ========================== */
  function validateForm(form) {
    var email = form.querySelector('[name="email"]');
    if (!email || !email.value.trim()) {
      alert('Please enter your email address.');
      return false;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value.trim())) {
      alert('Please enter a valid email address.');
      return false;
    }
    return true;
  }

  /* =========================
     Data collection
  ========================== */
  function collectFormData(form) {
    function getValue(name) {
      var el = form.querySelector('[name="' + name + '"]');
      return el ? el.value.trim() : '';
    }

    function getChecked(name) {
      var el = form.querySelector('[name="' + name + '"]:checked');
      return el ? el.value : '';
    }

    var greenBeans = Array.from(
      form.querySelectorAll('[data-checkbox-group="green_beans"]:checked')
    ).map(function (el) { return el.dataset.name; }).join('; ');

    return {
      email:                       getValue('email'),
      certified_roaster:           getChecked('certified_roaster'),
      roaster_team_size:           getValue('roaster_team_size'),
      green_beans:                 greenBeans,
      green_beans_other:           getValue('green_beans_other'),
      own_use_coffee_roaster:      getChecked('own_use_coffee_roaster'),
      coffee_roaster_brand:        getValue('coffee_roaster_brand'),
      coffee_roaster_brand_other:  getValue('coffee_roaster_brand_other'),
      where_you_roast_beans:       getValue('where_you_roast_beans'),
      where_you_roast_beans_other: getValue('where_you_roast_beans_other'),
      roast_time:                  getValue('roast_time'),
      how_you_roast:               getValue('how_you_roast'),
      how_you_roast_other:         getValue('how_you_roast_other'),
      where_you_store_coffee:      getValue('where_you_store_coffee'),
      user_type___roaster___cn:    'Yes',
      roaster_step:                'Step 2',
      context: {
        hutk:     getHubspotUTK(),
        pageUri:  window.location.href,
        pageName: document.title
      }
    };
  }

  /* =========================
     Webhook
  ========================== */
  function sendToWebhook(payload) {
    return fetch(WEBHOOK_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (res) {
      if (!res.ok) throw new Error('Webhook request failed');
    });
  }

  /* =========================
     Helpers
  ========================== */
  function getHubspotUTK() {
    var match = document.cookie.match(/hubspotutk=([^;]+)/);
    return match ? match[1] : '';
  }

  function resetBtn(btn) {
    if (!btn) return;
    btn.textContent = 'Submit';
    btn.disabled = false;
  }

})();
